// @ts-nocheck
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import PaykuImg from "../../assets/images/logoPayku.webp";
import BinanceImg from "../../assets/images/modal-icons/binance-exchange.svg";
import useCurrencyStore from "../../store/useCurrency.store";
import BinanceWithdrawal from "./BinanceWithdrawal";
import PaykuWithdrawal from "./PaykuWithdrawal";
import WithdrawalSteps from "./WithdrawalSteps";

// â”€â”€â”€ Shared card style (same as DepositMethods) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const cardBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 154,
  height: 88,
  borderRadius: 14,
  background: "transparent",
  border: "none",
  boxShadow: "none",
  cursor: "pointer",
  transition: "box-shadow 0.2s, transform 0.2s, background 0.2s",
  padding: "10px 14px",
  boxSizing: "border-box",
};
const cardHover = {
  background: "rgba(215,50,168,0.07)",
  boxShadow: "inset 0 0 0 1.5px rgba(215,50,168,0.6), 0 0 20px rgba(215,50,168,0.18)",
  transform: "translateY(-2px)",
};

const MethodCard = ({src, alt, onClick}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={e => { if (e.key === "Enter" || e.key === " ") onClick(); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={hovered ? {...cardBase, ...cardHover} : cardBase}
    >
      <img
        src={src}
        alt={alt}
        style={{maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: 8}}
      />
    </div>
  );
};

const PagoMovilCard = ({onClick}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={e => { if (e.key === "Enter" || e.key === " ") onClick(); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={hovered ? {...cardBase, ...cardHover} : cardBase}
    >
      <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 6}}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="2" width="14" height="20" rx="2" stroke="white" strokeWidth="1.5"/>
          <circle cx="12" cy="18" r="1" fill="white"/>
          <path d="M9 6h6M9 9h4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M14 12l-2.5 2.5L10 13" stroke="#fa5400" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span style={{color: "white", fontWeight: 700, fontSize: 11, letterSpacing: "0.02em", lineHeight: 1}}>Pago M&oacute;vil</span>
      </div>
    </div>
  );
};

const WithdrawalMethods = ({setWithdrawalModalWidth, closeModal}) => {
  const {t} = useTranslation();
  const [selected, setSelected] = useState(null);
  const selectedCurrency = useCurrencyStore(state => state.selectedCurrency);

  const handleCancelAll = () => {
    setSelected(null);
    if (typeof closeModal === "function") closeModal();
  };

  useEffect(() => {
    if (selected === "pagoMovil") {
      setWithdrawalModalWidth?.("978px");
    } else if (selected === "binance") {
      setWithdrawalModalWidth?.("678px");
    } else if (selected === "payku") {
      setWithdrawalModalWidth?.("878px");
    } else {
      setWithdrawalModalWidth?.("678px");
    }
  }, [selected, setWithdrawalModalWidth]);

  if (selected === "pagoMovil") {
    return <WithdrawalSteps onBack={() => setSelected(null)} onCancel={handleCancelAll} />;
  }
  if (selected === "binance") {
    return <BinanceWithdrawal onBack={() => setSelected(null)} onCancel={handleCancelAll} />;
  }
  if (selected === "payku") {
    return <PaykuWithdrawal onBack={() => setSelected(null)} onCancel={handleCancelAll} />;
  }

  return (
    <div style={{textAlign: "center", padding: "0 1rem"}}>
      <p style={{color: "var(--color-text-secondary)", fontSize: "0.875rem", marginBottom: "1.5rem"}}>
        Selecciona el m&eacute;todo de retiro
      </p>

      <div style={{display: "flex", justifyContent: "center", alignItems: "center", gap: 16, flexWrap: "wrap"}}>
        {selectedCurrency?.id !== "CLP" && (
          <PagoMovilCard onClick={() => setSelected("pagoMovil")} />
        )}
        <MethodCard src={BinanceImg} alt="Binance" onClick={() => setSelected("binance")} />
        {selectedCurrency?.id === "CLP" && (
          <MethodCard src={PaykuImg} alt="Payku" onClick={() => setSelected("payku")} />
        )}
      </div>

      {/* Cancel button */}
      <div style={{display: "flex", justifyContent: "center", marginTop: "24px"}}>
        <button
          type="button"
          onClick={handleCancelAll}
          style={{
            height: 38,
            padding: "0 32px",
            borderRadius: 999,
            border: "1.5px solid rgba(215,50,168,0.5)",
            background: "transparent",
            color: "rgba(215,50,168,0.9)",
            fontWeight: 600,
            fontSize: "0.875rem",
            cursor: "pointer",
            transition: "border-color 0.2s, background 0.2s, color 0.2s",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = "linear-gradient(135deg,#fa5400,#d732a8)";
            e.currentTarget.style.borderColor = "transparent";
            e.currentTarget.style.color = "#fff";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.borderColor = "rgba(215,50,168,0.5)";
            e.currentTarget.style.color = "rgba(215,50,168,0.9)";
          }}
        >
          {t("depositInstructionsCancelBtn")}
        </button>
      </div>
    </div>
  );
};

WithdrawalMethods.propTypes = {
  setWithdrawalModalWidth: PropTypes.func,
  closeModal: PropTypes.func,
};

export default WithdrawalMethods;
